import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import useWebcamRecorder from '../hooks/useWebcamRecorder'
import { lastEvent as lastEventSelector, lastEventId as lastEventIdSelector } from '../redux/webcamRecorderSlice'
import { CAMERA_STATUS } from '../helpers/cameraStatusConstants'
import { Notification } from './Notification'
import SidebarMenu from './SidebarMenu'

export function Layout1({ children }) {
  const { t } = useTranslation()
  useWebcamRecorder()

  const cameraLastEvent = useSelector(lastEventSelector)
  const cameraLastEventId = useSelector(lastEventIdSelector)
  const [uploadNotification, setUploadNotification] = useState({ show: false, title: '', description: '' })
  const baselineEventIdRef = useRef(cameraLastEventId)

  useEffect(() => {
    if (cameraLastEventId <= baselineEventIdRef.current) return
    if (cameraLastEvent === CAMERA_STATUS.UPLOAD_FAILED) {
      setUploadNotification({
        show: true,
        title: t('packing_camera_notifications.upload_failed_title'),
        description: t('packing_camera_notifications.upload_failed_description'),
      })
    } else if (cameraLastEvent === CAMERA_STATUS.UPLOAD_CHUNK_FAILED) {
      setUploadNotification({
        show: true,
        title: t('packing_camera_notifications.chunk_failed_title'),
        description: t('packing_camera_notifications.chunk_failed_description'),
      })
    }
    // t intentionally excluded from deps: language change must not refire a stale toast
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cameraLastEvent, cameraLastEventId])

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-100">
      <SidebarMenu />
      <main className="flex-1 min-w-0 overflow-auto flex flex-col">{children}</main>
      <Notification
        show={uploadNotification.show}
        setShow={show => setUploadNotification(prev => ({ ...prev, show }))}
        type="error"
        title={uploadNotification.title}
        description={uploadNotification.description}
      />
    </div>
  )
}
